import { FirebaseAuthConsumer } from '@smart-maps/firebase';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import { MOBILE_MAX_WIDTH, ZINDEX } from '../../constants';
import CloseButton from './close-button';
import FiltersView from './filters';
import LoginView from './login';
import Navigation from './navigation';
import ProfileView from './profile';
import TrophiesView from './trophies';

const useStyles = createUseStyles({
  menu: {
    '&.ismobile': { width: 'calc(100% - 24px)' },
    '&.opened': { borderRadius: 12 },
    borderRadius: 25,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    composes: ['is-absolute', 'no-overflow'],
    left: 12,
    top: 12,
    transition: 'border-radius 0.3s',
    width: 320,
    zIndex: ZINDEX.MAP_CONTROLS,
  },
  panel: {
    '&.opened': {
      height: 'auto',
      paddingBottom: 12,
      paddingTop: 12,
    },
    height: 0,
    transition: 'height 0.3s',
  },
  wrapper: {
    composes: ['is-relative', 'flex-rows'],
    height: '100%',
    width: '100%',
  },
});

const MenuComponent = React.memo(({ lmap }) => {
  const classes = useStyles();
  const navigation = useSelector(_ => _.navigation);

  const ismobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
  const opened = navigation !== null;

  return (
    <div className={classnames(classes.menu, { ismobile, opened })}>
      <div className={classnames(classes.wrapper, 'smart-maps-menu')}>
        <Navigation opened={navigation} />
        <FirebaseAuthConsumer>
          {({ user }) => (
            <div className={classnames(classes.panel, { opened })}>
              {navigation === 'login' && !user && <LoginView />}
              {navigation === 'login' && user && <ProfileView user={user} />}
              {navigation === 'filters' && <FiltersView />}
              {navigation === 'trophy' && <TrophiesView lmap={lmap} />}
            </div>
          )}
        </FirebaseAuthConsumer>
        {opened && <CloseButton />}
      </div>
    </div>
  );
});

MenuComponent.propTypes = {
  lmap: PropTypes.shape().isRequired,
};

MenuComponent.displayName = 'MenuComponent';

export default MenuComponent;
